import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import * as filters from "./util/filter";
import VueMask from 'v-mask'

Vue.config.productionTip = false
Vue.use(VueMask);
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
